import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment)

const sortObject = (unordered) => {
    return Object.keys(unordered).sort().reduce((object, key) => {
        object[key] = unordered[key];
        return object;
    }, {});
};


const secToMin = (value) => moment.duration(value, 'seconds').format('h [hrs] m [mins] ss [secs]');

const sortTasks = (tasks) => { 
    if (!tasks) return [];
    return Object.keys(tasks).sort((first, seconds) => (+first.replace('task','')) - (+seconds.replace('task','')));
};

const formatChart = ({ data, formatter }) => {
    return Object.keys(data).reduce((object, name) => {
        object.chart.labels = data[name].labels;

        const totalFormatter = data[name].series.map((timeSeries) => formatter(timeSeries))

        object.chart.series.push({
            name: name.charAt(0).toUpperCase() + name.slice(1),
            type: 'bar',
            data: totalFormatter
        });

        object[name] = secToMin(+totalFormatter.reduce((total, time) => total + time, 0));
        
        return object;
    }, { chart: { labels: [], series: [] } });
}


export { sortObject, formatChart, sortTasks, secToMin }